module.exports = __webpack_public_path__ + "static/analytics-new-product-211615dcf0d688dc59fc7a6dc4db130e.png";